<template>
  <div
    v-intersect
    class="filter-bool"
    @intersect:enter="onShow"
  >
    <BaseCheckbox
      class="filter-bool__item"
      :class="{ 'disabled-color': !filter.count }"
      :model-value="!!selected"
      @change="onChange"
    >
      {{ filter.name }}
    </BaseCheckbox>
  </div>
</template>

<script setup lang="ts">
import type { CatalogFilter, FilterItemChangePayload } from '~/types/catalog'

type Props = {
  filter: CatalogFilter
  selected?: string
}
type Emits = {
  (e: 'on-change' | 'on-show', value: FilterItemChangePayload): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const onChange = () => {
  emit('on-change', {
    filter_code: props.filter.code,
    filter_name: props.filter.name,
    value: 'true'
  })
}

const onShow = () => {
  emit('on-show', {
    filter_code: props.filter.code,
    filter_name: props.filter.name,
  })
}

</script>

<style scoped lang="scss">
.filter-bool {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 1.1rem;
  margin-bottom: 1.1rem;
  line-height: 2rem;
  height: 2rem;
  border: none;
  &:last-of-type {
    margin-bottom: 0;
  }
  &__item {
    &.disabled-color {
      color: $gray-color;
    }
  }
}
</style>
